import FadeIn from "../components/FadeIn";

const Terms = () => {
    return (
        <main data-testid="page-terms" className="bg-white text-[#111111]">
            <section className="pt-40 md:pt-56 pb-12 md:pb-20">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
                    <FadeIn className="col-span-12 md:col-span-4">
                        <div className="text-[11px] tracking-luxury uppercase text-[#888]">
                            Information
                        </div>
                    </FadeIn>
                    <FadeIn delay={0.1} className="col-span-12 md:col-span-8">
                        <h1 className="font-serif font-light text-5xl md:text-7xl leading-[0.95] tracking-tight">
                            Vilkår & betingelser
                        </h1>
                    </FadeIn>
                </div>
            </section>

            <section className="pb-32 md:pb-48 border-t border-[#EAE8E4] pt-16 md:pt-24">
                <div className="max-w-[1440px] mx-auto px-6 md:px-12 grid grid-cols-12 gap-6">
                    <FadeIn className="col-span-12 md:col-span-8 md:col-start-3 space-y-10 text-base md:text-lg text-[#222] leading-relaxed">
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Introduktion
                            </h2>
                            <p>
                                Velkommen til mmbr.dk. Ved at besøge denne hjemmeside accepterer
                                du at overholde og være bundet af følgende vilkår og betingelser.
                                Læs dem venligst omhyggeligt.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Immaterielle rettigheder
                            </h2>
                            <p>
                                Alt indhold, herunder tekst, grafik, logoer, billeder og software,
                                på denne hjemmeside tilhører MM Byggeri & Rådgivning eller dets
                                indholdsleverandører og er beskyttet af internationale
                                ophavsretslove. Uautoriseret brug eller distribution af materiale
                                fra denne side er forbudt.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Brug af hjemmesiden
                            </h2>
                            <p>
                                Du får en begrænset, ikke-eksklusiv, tilbagekaldelig licens til at
                                få adgang til og bruge denne hjemmeside til personlige,
                                ikke-kommercielle formål. Du accepterer ikke at bruge hjemmesiden
                                til nogen ulovlige eller uautoriserede formål.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Brugerindhold
                            </h2>
                            <p>
                                Du er ansvarlig for alt indhold, som du uploader, poster eller på
                                anden måde gør tilgængeligt via hjemmesiden. Ved at indsende
                                indhold til mmbr.dk giver du MM Byggeri & Rådgivning en evig,
                                uigenkaldelig, verdensomspændende, royaltyfri licens til at bruge,
                                reproducere, ændre, offentliggøre og distribuere dette indhold.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Ansvarsfraskrivelse
                            </h2>
                            <p>
                                MM Byggeri & Rådgivning bestræber sig på at sikre, at oplysningerne
                                på denne hjemmeside er korrekte, men giver ingen garantier for
                                nøjagtigheden, fuldstændigheden eller aktualiteten af indholdet.
                                Hjemmesiden leveres &ldquo;som den er&rdquo; og &ldquo;som
                                tilgængelig&rdquo; uden nogen form for garanti, hverken
                                udtrykkelig eller underforstået.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Begrænsning af ansvar
                            </h2>
                            <p>
                                MM Byggeri & Rådgivning kan ikke holdes ansvarlig for nogen
                                direkte, indirekte, tilfældige, specielle eller følgeskader, der
                                opstår som følge af brugen af eller manglende evne til at bruge
                                denne hjemmeside.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Ændringer i vilkår
                            </h2>
                            <p>
                                MM Byggeri & Rådgivning forbeholder sig retten til at ændre disse
                                vilkår og betingelser til enhver tid. Ændringer vil blive
                                offentliggjort på denne side, og det er dit ansvar at gennemgå
                                vilkårene regelmæssigt for at sikre, at du er opmærksom på
                                eventuelle ændringer.
                            </p>
                        </div>
                        <div>
                            <h2 className="font-serif text-2xl md:text-3xl mb-4">
                                Lovvalg og værneting
                            </h2>
                            <p>
                                Disse vilkår og betingelser er underlagt dansk lovgivning.
                                Eventuelle tvister, der opstår i forbindelse med disse vilkår og
                                betingelser, skal afgøres ved de danske domstole.
                            </p>
                        </div>
                    </FadeIn>
                </div>
            </section>
        </main>
    );
};

export default Terms;
